import React from 'react';
import { isMobile } from 'react-device-detect';
import { Block, Heading, Text } from '../../../../../../components';
import { BackButton } from '../../../../components';
import Modal from '../../../../components/Modal/Modal';
import RequestExist from '@/presentation/modules/procedures/components/Modals/RequestExists';
import NotAvailable from '@/presentation/modules/procedures/components/Modals/NotAvailable';
import Spinner from '../../../../../../components/Spinner';
import {
  ContainerProcedure,
  SubContainer
} from '../../../certificates-constancies/type1/info/components';
import { BtnRequest } from '../../IssuanceUniversityCard/info/components/styled';
import ProcedureHeader from '@/presentation/modules/procedures/components/ContainerProcedure/Header';

interface RetirementPeriodInfoViewProps {
  isLoading: boolean;
  procedureSelectedInfo: any;
  handleNewRequest: () => void;
  handleBack: () => void;
  handleExistRequest: () => void;
  handleCloseModalConfirmation: () => void;
  handleCloseModalNotAvailable: () => void;
  handleCloseModalError: () => void;
  showModalConfirmation: boolean;
  showModalNotAvailable: boolean;
  showModalError: boolean;
  modalTitle?: string;
}

const RetirementPeriodInfoView: React.FC<RetirementPeriodInfoViewProps> = ({
  isLoading,
  procedureSelectedInfo,
  handleNewRequest,
  handleBack,
  handleExistRequest,
  handleCloseModalConfirmation,
  handleCloseModalNotAvailable,
  handleCloseModalError,
  showModalConfirmation,
  showModalNotAvailable,
  showModalError,
  modalTitle
}) => (
  <ContainerProcedure>
    <SubContainer style={{ marginBottom: 24 }}>
      <BackButton onClick={handleBack} />
    </SubContainer>

    <Heading
      text="Retiro de periodo lectivo"
      level={2}
      color="var(--text-text02)"
      size={24}
      lineHeight={32}
      fontWeight="700"
      className="headingCustom"
      align="flex-start"
    />

    {isLoading ? (
      <Spinner />
    ) : (
      <Block
        customized
        justifyContent="flex-start"
        alignItems="center"
        className="headingCustom"
        gap="16px"
        margin="0px auto"
      >
        <ProcedureHeader
          amount={procedureSelectedInfo?.amount}
          duration={procedureSelectedInfo?.duration}
          date={procedureSelectedInfo?.endDate}
          paddingData={12}
        />

        <Block
          customized
          maxWidth={isMobile ? '100%' : '744px'}
          backgroundColor="#fff"
          borderRadius="8px"
        >
          <Block customized padding="12px 16px">
            <Text
              color="#161D1F"
              fontSize="14px"
              lineHeight="12x"
              fontWeight="400"
            >
              El retiro del periodo lectivo es un trámite voluntario que permite
              al alumno retirarse del ciclo académico actual.
            </Text>
          </Block>
        </Block>

        <Block
          customized
          maxWidth={isMobile ? '100%' : '744px'}
          backgroundColor="#fff"
          padding="16px"
          borderRadius="8px"
        >
          <Heading
            text="Consideraciones"
            level={3}
            color="var(--text-text02)"
            size={14}
            lineHeight={20}
            fontWeight="700"
            align="flex-start"
            width="100%"
          />
          <Block customized padding="4px 0px 0px 16px">
            <ul style={{ listStyleType: 'disc' }}>
              <li>
                De aplicar la solicitud, solo se revertirán las cuotas no
                vencidas, el pago de las cuotas vencidas no será exonerado.
              </li>
              <li>
                No recibirás calificaciones, ni repitencia en las asignaturas
                matriculadas.
              </li>
              <li>No debes tener sanción disciplinaria.</li>
              <li>La confirmación será enviada a tu correo UTP.</li>
            </ul>
          </Block>
        </Block>

        <Block
          customized
          maxWidth={isMobile ? '100%' : '744px'}
          backgroundColor="#fff"
          padding="16px"
          borderRadius="8px"
        >
          <Heading
            text="Pasos a seguir:"
            level={3}
            color="var(--text-text02)"
            size={14}
            lineHeight={20}
            fontWeight="700"
            align="flex-start"
            width="100%"
          />
          <Block customized padding="4px 0px 0px 16px">
            <ol style={{ listStyle: 'decimal' }}>
              <li>
                Completa la información solicitada.
                <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
                  <li>
                    Selecciona el motivo de retiro e ingresa número y horario de
                    contacto.
                  </li>
                </ul>
              </li>
              <li>
                Espera la llamada que recibirás al número registrado en tu
                solicitud.
              </li>
              <li>Te notificaremos el estado de tu trámite en UTP+app.</li>
            </ol>
          </Block>
        </Block>

        <Block
          customized
          justifyContent="flex-start"
          alignItems="center"
          className="container"
          gap="16px"
          margin="0px auto"
        >
          <div style={{ width: '100%', maxWidth: '744px' }}>
            <BtnRequest onClick={handleNewRequest}>
              <p>Empezar solicitud</p>
            </BtnRequest>
          </div>
        </Block>
      </Block>
    )}

    <Modal
      show={showModalConfirmation}
      handleClose={handleCloseModalConfirmation}
    >
      <RequestExist handleClick={handleExistRequest} />
    </Modal>
    <Modal
      show={showModalNotAvailable}
      handleClose={handleCloseModalNotAvailable}
    >
      <NotAvailable handleClick={handleCloseModalNotAvailable} />
    </Modal>
    <Modal show={showModalError} handleClose={handleCloseModalError}>
      <NotAvailable textInformation={modalTitle} handleClick={handleBack} />
    </Modal>
  </ContainerProcedure>
);

export default RetirementPeriodInfoView;
